import * as React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import PhoneForm from './PhoneForm';
import { messages, lang} from './i18n';
import { IntlProvider } from 'react-intl';

export interface Props {
  error: boolean;
  phone: string;
  authToken: string;
  id: string;
}

export interface State {
  locale: string;
  messages: Object;
}

const Wrapper = styled.div`
`;

class App extends React.Component<Props, State> {
  error: boolean;
  phone: string;
  constructor (props: Props, state: State) {
    super(props);
    this.state = {
      locale: lang,
      messages: messages[lang],
    };
  }
  render () {
    const {error, phone, authToken, id} = this.props;
    return (
      <IntlProvider
        locale={this.state.locale}
        messages={this.state.messages}
      >
        <Wrapper>
          <Header />
          <PhoneForm error={error} phone={phone} authToken={authToken} id={id} />
          <Footer country="jp" />
        </Wrapper>
      </IntlProvider>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/App.tsx